import {
  Paper,
  LegacyBox,
  LegacyText,
  styled,
  Button,
  Divider,
} from '@gogame/components';

import LinkRouter from 'scenes/MarketingPlanning/MarketingPlanningWizard/MarketingPlanningPreview/components/LinkRouter';

export const TreeWrapper = styled(LegacyBox)`
  max-height: 100%;
  margin-left: ${({ dataOpenTree }) => (dataOpenTree ? null : '-16px')};
  height: ${({ dataOpenTree }) => (dataOpenTree ? null : '100%')};
`;

export const TreePaper = styled(Paper)`
  width: 550px;
  max-height: 100%;
  display: flex;
  flex-direction: column;
`;

export const ItemTitleLinkRouter = styled(LinkRouter)`
  text-decoration: none;

  &:hover {
    text-decoration: none;
  }
`;

export const TotalItemBox = styled(LegacyBox)`
  height: 64px;
  padding: 0 16px;
  flex: 0 0 auto;
`;

export const TotalTitleText = styled(LegacyText)`
  font-size: 20px;
  color: ${({ link, theme }) => (link ? theme.palette.primary.main : null)};
  text-transform: uppercase;
`;

export const ActivityTypeBudgetBox = styled(LegacyBox)`
  position: relative;
`;

export const ActivityTypeBudgetText = styled(LegacyText)`
  font-size: 14px;
  color: ${({ error, theme }) => (error ? theme.palette.error.main : null)};
`;

export const ItemTitleBox = styled(LegacyBox)`
  padding-left: ${({ depth }) => `${16 * (depth - 1)}px`};
  text-transform: ${({ depth }) => (depth < 2 ? 'uppercase' : null)};
  min-height: ${({ singleRow }) => (singleRow ? '32px' : '48px')};
  min-width: 200px;
`;

export const TitleText = styled(LegacyText)`
  line-height: 1;
  font-weight: ${({ current }) => (current ? '500' : null)};
  font-size: ${({ depth }) => (depth ? '14px' : '13px')};
`;

export const SubtitleText = styled(LegacyText)`
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ButtonToggle = styled(Button)`
  height: 100%;
  padding: 0;
  flex-direction: column;
  min-width: 32px;
`;

export const DividerVertical = styled(Divider)`
  flex: 1 1 auto;
  width: 1px;
  height: auto;
`;
